interface StatusBadgeProps {
  status: 'pending' | 'partial' | 'complete' | 'resolved' | 'action_required';
}

const statusConfig = {
  pending: {
    label: 'Pending',
    className: 'bg-yellow-100 text-yellow-800',
    icon: null,
  },
  partial: {
    label: 'Partial',
    className: 'bg-blue-100 text-blue-800',
    icon: null,
  },
  complete: {
    label: 'Complete',
    className: 'bg-green-100 text-green-800',
    icon: null,
  },
  resolved: {
    label: 'Resolved',
    className: 'bg-green-100 text-green-800',
    icon: null,
  },
  action_required: {
    label: 'Action Required',
    className: 'bg-red-100 text-red-800',
    icon: (
      <svg className="w-3.5 h-3.5 mr-1" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.345 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}
    >
      {config.icon}
      {config.label}
    </span>
  );
}
